/**
 * Esqueletos de carga (pedido del owner: «todo debería tener skeleton para
 * saber qué espera o no algo en render»).
 *
 * Un «Cargando…» de texto no dice QUÉ va a aparecer ni CUÁNTO ocupa; el
 * esqueleto reserva la silueta del contenido real, así la página no salta
 * cuando llegan los datos (misma regla de geometría fija del grabador).
 *
 * Tokens, no hex: el shimmer es `bg-surface-sunken` con pulso — funciona en
 * claro (Bolsillo) y en navy (Cabina/Pantalla) sin ramificar por tema.
 */

/** Barra base. Dale forma con className (h-4 w-2/3, h-10 w-full, etc.). */
export function Esqueleto({ className = '' }: { className?: string }) {
  return (
    <span
      className={`block animate-pulse rounded-md bg-surface-sunken ${className}`}
      aria-hidden="true"
    />
  );
}

/** Párrafo fantasma: n líneas de texto, la última más corta. */
export function EsqueletoLineas({
  lineas = 3,
  className = '',
}: {
  lineas?: number;
  className?: string;
}) {
  return (
    <div role="status" aria-label="Cargando" className={`flex flex-col gap-2 ${className}`}>
      {Array.from({ length: lineas }, (_, i) => (
        <Esqueleto key={i} className={`h-4 ${i === lineas - 1 ? 'w-2/5' : 'w-full'}`} />
      ))}
    </div>
  );
}

/**
 * Filas fantasma del feed de aportes (Cabina): renglón de contenido + línea
 * de proveniencia (autor · grupo), como la fila real.
 */
export function EsqueletoAportes({ filas = 3 }: { filas?: number }) {
  return (
    <ul role="status" aria-label="Cargando aportes" className="flex flex-col divide-y divide-border">
      {Array.from({ length: filas }, (_, i) => (
        <li key={i} className="flex flex-col gap-2 py-2.5 first:pt-0 last:pb-0">
          <Esqueleto className={`h-4 ${i % 2 ? 'w-3/4' : 'w-full'}`} />
          <Esqueleto className="h-3 w-1/3" />
        </li>
      ))}
    </ul>
  );
}

/** Tarjeta fantasma: título + cuerpo, para listas de tarjetas (procesos, tablero). */
export function EsqueletoTarjeta({ className = '' }: { className?: string }) {
  return (
    <div
      role="status"
      aria-label="Cargando"
      className={`rounded-lg border border-border bg-surface-raised px-4 py-4 ${className}`}
    >
      <Esqueleto className="h-5 w-1/2" />
      <EsqueletoLineas lineas={2} className="mt-3" />
    </div>
  );
}
